const heroWrapperResizeTimeout = {};
export const InitializeHeroWrapperHandler = function() {
    /**
     * @this {Object} - This defines the type of `this` for this function.
     * @property {HTMLVideoElement} video - The video element.
     * @property {Element} desktopSource - The desktop source element.
     * @property {Element} mobileSource - The mobile source element.
     * @property {number} index - index of the current hero wrapper
     */
    const handleHeroItemResize = function() {
        // Mobile only
        if (window.innerWidth < 640) {
            if (!this.mobileSource) {
                this.video.pause();
                this.video.classList.add('hide');
            } else {
                if (this.video.src !== this.mobileSource.src) {
                    this.video.src = this.mobileSource.src;
                    this.video.load();
                }

                if (!this.video.paused) return;
                this.video.classList.remove('hide');
            }
        }

        // Desktop only
        if (window.innerWidth >= 640) {
            if (!this.desktopSource) {
                this.video.pause();
                this.video.classList.add('hide');
            } else {
                if (this.video.src !== this.desktopSource.src) {
                    this.video.src = this.desktopSource.src;
                    this.video.load();
                }

                if (!this.video.paused) return;
                this.video.classList.remove('hide');
            }
        }
    }

    /**
     * @param {number} index
     */
    const initializeHeroItem = function(index) {
        heroWrapperResizeTimeout[index] = 0;

        /**
         * @type {HTMLVideoElement}
         */
        const video = this.querySelector('video');
        if (!video) return;

        const desktopSource = video.querySelector('.src-desktop');
        const mobileSource = video.querySelector('.src-mobile');

        const resizeHandlerProxy = () => {
            if (heroWrapperResizeTimeout[index]) {
                clearTimeout(heroWrapperResizeTimeout[index]);
            }

            heroWrapperResizeTimeout[index] = setTimeout(handleHeroItemResize.bind({
                video,
                desktopSource,
                mobileSource,
                index
            }), 100);
        }

        // Bind the handler once when adding the event listener
        window.addEventListener('resize', resizeHandlerProxy);
        resizeHandlerProxy();
    }

    const __constructor = () => {
        const heroWrappers = document.querySelectorAll('.hero-wrapper');
        if (!heroWrappers.length) return;

        heroWrappers.forEach((hero, index) => initializeHeroItem.bind(hero)(index));
    }

    __constructor();
}
